// <script>
module.exports = {
    methods: {
        jump: function(index) {
            location.href ="#/helpDetail/" + index
        }
    },
    components: {
        'hd': require('c/near_powerstation/header.vue')
    }
}
// </script>
//
//
//
// <template>
//     <div class="help">
//         <hd title="使用帮助"></hd>
//         <div class="black"></div>
//         <div class="help_wrapper">
//             <h1 class="title">常见问题</h1>
//             <ul>
//                 <li v-touch:tap="jump(1)">用车指导及注意事项</li>
//                 <li v-touch:tap="jump(2)">车辆续航及充电</li>
//                 <li v-touch:tap="jump(3)">用车规则</li>
//             </ul>
//             <h1 class="title">违章及事故处理</h1>
//             <ul>
//                 <li v-touch:tap="jump(4)">事故处理步骤</li>
//                 <li v-touch:tap="jump(5)">违章查询及处理</li>
//             </ul>
//             <h1 class="title">费用问题</h1>
//             <ul>
//                 <li v-touch:tap="jump(6)">关于押金</li>
//                 <li v-touch:tap="jump(7)">用车收费</li>
//                 <li v-touch:tap="jump(8)">其他违规情况收费</li>
//             </ul>
//             <h1 class="title">其他问题</h1>
//             <ul>
//                 <li v-touch:tap="jump(9)">取消订单次数过多无法下单？</li>
//                 <li v-touch:tap="jump(10)">无法使用优惠券？</li>
//             </ul>
//         </div>
//     </div>
//
// </template>
//
//
// <style lang="sass"  scoped>
//      .help{
//         width:100%;
//         min-height:100%;
//         .black{
//             height: .213333rem;
//         }
//         .m-t8{
//             margin-top:.213333rem;
//         }
//         .help_wrapper{
//             background:#fff;
//             .title{
//                 height: 1.146667rem;
//                 line-height: 1.146667rem;
//                 padding-left:.426667rem;
//                 box-sizing:border-box;
//                 position:relative;
//                 font-size:16px;
//                 margin-top:.106667rem;
//                 &:first-child{
//                     margin-top:0;
//                 }
//                 &:before{
//                     content:"";
//                     position:absolute;
//                     left:0;
//                     top:50%;
//                     transform:translateY(-50%);
//                     height:100%;
//                     width:4px;
//                     height:14px;
//                     background: #4097FC;
//                 }
//             }
//         }
//         ul{
//             width: 100%;
//             padding-left: .64rem;
//             box-sizing:border-box;
//             li{
//                 width: 100%;
//                 height: 1.146667rem;
//                 line-height: 1.146667rem;
//                 font-size: .373333rem;
//                 color: #252F3A;
//                 position:relative;
//                 &:before{
//                     content: "";
//                     position: absolute;
//                     width: .213333rem;
//                     height: .213333rem;
//                     right: .373333rem;
//                     top: 50%;
//                     border-top: 1px solid #666D75;
//                     border-right: 1px solid #666D75;
//                     transform: translateY(-50%) rotate(45deg);
//                 }
//             }
//         }
//      }
// </style>
//
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/static_page/help.vue